export default __webpack_public_path__ + "images/MovIcon.f92443e352805daa953ceb8ece3a5a96.png";